window.addEventListener('load', () => {
    const shopifySections = document.querySelectorAll('main .shopify-section');
    shopifySections[2].dataset.refresh = true;
    const innerHTMLScreenshot = shopifySections[2].innerHTML;
    let i = 0;

    const verificator = setInterval(() => {
        if (i > 10) {
            clearInterval(verificator);
            return;
        }

        shopifySections.forEach((section) => {
            section.dataset.refresh = true;
        });

        i++;
    }, 500);
});

class SwatchManager {
  constructor(productVariants, colorSwatches, sizeSwatches) {
    this.productVariants = productVariants;
    this.colorSwatches = colorSwatches;
    this.sizeSwatches = sizeSwatches;
    this.options = {};  //Object that stores the available sizes of each colors

    this.getAllAvailableOptions();
    this.disableSwatchesOnPageLoad();
    this.setEventListenerForSwatches();
  }

  getAllAvailableOptions() {
    //If the color is not in the options array, we add it with a size array to store the available sizes for this color
    this.colorSwatches.forEach(color => {
      let colorName = color.dataset.label.trim();
      this.options[colorName] = {
        sizes: []
      };

      this.productVariants.forEach(variant => {
        if (variant.option1.trim() === colorName && variant.available) {
          this.options[colorName].sizes.push(variant.option2);
        }
      })
    })
  }

  disableSwatchesOnPageLoad() {
    //on page load, detect current variant color and size and apply the correct filters
    let currentVariant = this.productVariants.find(variant => {
      return variant.is_selected === true;
    })

    //if no currentVariant returned we check for the first available variant
    if (!currentVariant) {
      currentVariant = this.productVariants.find(variant => {
        return variant.is_first_available === true;
      })
    }

    this.disableUnavailableSizes(currentVariant.option1);
    this.disableUnavailableColors(currentVariant.option2);
  } 

  setEventListenerForSwatches() {
    this.colorSwatches.forEach(color => {
      color.addEventListener('click', () => {
        this.resetAllSizes();
        this.disableUnavailableSizes(color.dataset.label);
      })
    })

    this.sizeSwatches.forEach(size => {
      size.addEventListener('click', () => {
        this.resetAllColors();
        this.disableUnavailableColors(size.dataset.label);
      })
    })
  }

  disableUnavailableColors(size) {
    size = size.trim();
    //to find available colors we need to search the options array and find
    let availableColors = [];
    Object.keys(this.options).forEach(key => {
      if (this.options[key].sizes.includes(size)) {
        availableColors.push(key);
      }
    })

    this.colorSwatches.forEach(color => {
      if (!availableColors.includes(color.dataset.label)) {
        color.classList.add('disabled');
      }
    })
  }

  resetAllColors() {
    this.colorSwatches.forEach(color => {
      color.classList.remove('disabled');
    })
  }

  disableUnavailableSizes(color) {
    color = color.trim();
    let availableSizes = this.options[color].sizes;

    this.sizeSwatches.forEach(size => {
      if (!availableSizes.includes(size.dataset.label)) {
        size.classList.add('disabled');
      }
    })
  }

  resetAllSizes() {
    this.sizeSwatches.forEach(size => {
      size.classList.remove('disabled');
    })
  }
}

function hasWhiteSpace(s) {
  return /\s/g.test(s);
} 

function processSearchQuery(searchInput, searchSubmit, searchForm) {
  searchSubmit.addEventListener('click', function(e) {
    e.preventDefault();

    //If no white space, surround the search value with quotes
    if (!hasWhiteSpace(searchInput.value) && searchInput.value.length > 0) {
      
      //Make sure there are no quotes already at the beginning or end of the search value
      if (!searchInput.value.startsWith('"')) {
        searchInput.value = '"' + searchInput.value;
      }
      if (!searchInput.value.endsWith('"')) {
        searchInput.value = searchInput.value + '"';
      }
    }

    searchForm.submit();
  });
}